import { render, staticRenderFns } from "./LabTierBoard.vue?vue&type=template&id=3ce59341&scoped=true"
import script from "./LabTierBoard.vue?vue&type=script&lang=js"
export * from "./LabTierBoard.vue?vue&type=script&lang=js"
import style0 from "./LabTierBoard.vue?vue&type=style&index=0&id=3ce59341&prod&scoped=true&lang=css"
import style1 from "./LabTierBoard.vue?vue&type=style&index=1&id=3ce59341&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce59341",
  null
  
)

export default component.exports